if (typeof PdpImageBanner !== "function") {
  class PdpImageBanner extends HTMLElement {
    constructor() {
      super();
      this.imgArray = this._getImgArray();
      if (!this.imgArray) return;

      this._initializeBanner();

      // Adding a listener for the 'refresh' event
      this.addEventListener("refresh", this.refreshBanner.bind(this));
    }

    _getImgArray() {
      var imgArray = document.body.getAttribute("data-banner-imgs");
      if (!imgArray) return null;
      imgArray = imgArray.split(",");
      imgArray.pop();
      return imgArray;
    }

    _initializeBanner() {
      let imgArray = this.imgArray;
      this.responsiveHTML = "<picture>";

      for (var i = imgArray.length; i >= 0; i--) {
        if (i == 0) {
          this.responsiveHTML += `
            <source media="(min-width: 1025px)" srcset="${imgArray[i]}">
            <img src="${imgArray[i]}"></img>`;
        } else if (i == 1) {
          this.responsiveHTML += `<source media="(min-width: 1024)" srcset="${imgArray[i]}">`;
        } else if (i == 2) {
          this.responsiveHTML += `<source media="(max-width: 767px)" srcset="${imgArray[i]}">`;
        }
      }

      this.responsiveHTML += "</picture>";

      // If shadow root doesn't exist, create it
      if (!this.shadowRoot) {
        this.shadow = this.attachShadow({ mode: "open" });
      } else {
        this.shadow = this.shadowRoot;
      }

      this.shadow.innerHTML = this.responsiveHTML;

      const style = document.createElement("style");
      style.textContent = `
        picture {
          width: 100%;
          margin-bottom: -40px;
          display: block;
        }

        img {
          width: 100%;
          height: 100%;
        }
      `;
      this.shadow.appendChild(style);
      console.log("PdpImageBanner init", imgArray, this.responsiveHTML);
    }

    // Refresh method to rebuild the banner with updated images
    refreshBanner() {
      this.imgArray = this._getImgArray(); // Get the new images
      this._initializeBanner(); // Reinitialize the banner content
      console.log("PdpImageBanner refreshed", this.imgArray);
    }
  }

  if (typeof customElements.get("variant-pdp-banner-image") == "undefined") {
    customElements.define("variant-pdp-banner-image", PdpImageBanner);
  }
}
